package kz.dentalcrm.app.screens.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.cancel
import dentalcrm.composeapp.generated.resources.confirm
import dentalcrm.composeapp.generated.resources.log_out_confirm
import kz.dentalcrm.app.core.ui.components.UIButton
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource

@Composable
fun LogOutDialog(
    title: String,
    message: String,
    confirm: () -> Unit,
    cancel: () -> Unit,
    onDismiss: () -> Unit
) {
    Dialog(
        onDismissRequest = { onDismiss() },
        properties = DialogProperties(
            usePlatformDefaultWidth = false,
        )
    ) {
        Box(
            modifier = Modifier.widthIn(min = 320.dp, max = 420.dp)
                .padding(16.dp),
            contentAlignment = Alignment.Center
        ) {
            Column(
                modifier = Modifier
                    .imePadding()
                    .background(
                        color = DefaultTheme.colors.surfaceAlternative,
                        shape = RoundedCornerShape(24.dp)
                    ),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                Spacer(modifier = Modifier.height(24.dp))
                Text(
                    modifier = Modifier.padding(horizontal = 16.dp),
                    textAlign = TextAlign.Center,
                    text = title,
                    style = DefaultTheme.typography.subHeading2,
                    color = DefaultTheme.colors.onSurface
                )
                Spacer(modifier = Modifier.height(4.dp))
                Text(
                    modifier = Modifier.padding(horizontal = 16.dp),
                    textAlign = TextAlign.Center,
                    text = message,
                    style = DefaultTheme.typography.bodySmallRegular,
                    color = DefaultTheme.colors.onSurface
                )
                Spacer(modifier = Modifier.height(24.dp))
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp),
                    horizontalArrangement = Arrangement.Center
                ) {
                    UIButton(
                        modifier = Modifier.weight(1f).height(40.dp),
                        text = stringResource(Res.string.cancel),
                        containerColor = Color.Transparent,
                        contentColor = DefaultTheme.colors.onSurface,
                        style = DefaultTheme.typography.bodySmallRegular,
                        onClick = {
                            cancel()
                            onDismiss()
                        }
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    UIButton(
                        modifier = Modifier.weight(1f).height(40.dp),
                        text = stringResource(Res.string.log_out_confirm),
                        style = DefaultTheme.typography.bodySmallRegular,
                        containerColor = DefaultTheme.colors.error,
                        contentColor = DefaultTheme.colors.onPrimary,
                        onClick = {
                            confirm()
                            onDismiss()
                        }
                    )
                }
                Spacer(modifier = Modifier.height(24.dp))
            }
        }
    }
}